import React, { useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';


import moment from 'moment';
import {
  Button,
  TextField,
  Typography,
  Grid,
  Chip,
  Autocomplete,
  Divider,
  Box,
  CircularProgress,
  Card,
  CardHeader,
} from '@mui/material';
import { Container } from 'reactstrap';
import ReactApexChart from "react-apexcharts"
import Avatar from '@mui/material/Avatar';
import PhoneIcon from '@mui/icons-material/Phone';
import BusinessIcon from '@mui/icons-material/Business';
import BadgeIcon from '@mui/icons-material/Badge';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalConvenienceStoreIcon from '@mui/icons-material/LocalConvenienceStore';
import WarningIcon from '@mui/icons-material/Warning';
import DescriptionIcon from '@mui/icons-material/Description';
import EmailIcon from '@mui/icons-material/Email';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import CircleIcon from '@mui/icons-material/Circle';
import Badge from '@mui/material/Badge';
import Popover from '@mui/material/Popover';
import axios from '../utils/axios';
// sections
import {
  AppOrderTimeline,
  AppCurrentVisits,
  AppWidgetSummary,
} from '../sections/@dashboard/app';
import UIContext from '../context/UIContext';
// import { autoBatchEnhancer } from '@reduxjs/toolkit';




// ----------------------------------------------------------------------

export default function DashboardAppPage() {

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);


  const [adminData, setadminData] = useState([])
  const [loading, setLoading] = useState(true); // Track loading state

  const [Series10, setSeries10] = useState('')
  const [Series11, setSeries11] = useState('')

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [anchorEl1, setanchorEl1] = useState(null)
  const [anchorEl2, setanchorEl2] = useState(null)
  const [popOverData, setpopOverData] = useState([])
  const [countryList, setCountryList] = useState([]);
  const [branchList, setBranchList] = useState([]);


  const [filterInputs, setFilterInputs] = useState({
    fromDate: moment().startOf('month').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    Branch: '',
    senderCountry: '',
    receiverCountry: ''
  });

  useEffect(() => {
    GetAllAdminDashboard();
    GetPopOverDatas();
    GetCountryList();
    GetBranchList(sessionStorage.getItem('Origin'));
  }, [])

  useLayoutEffect(() => {

    // GetPopOverDatas()
  }, [])

  const theme = useTheme();


  const GetAllAdminDashboard = async () => {
    try {
      setLoading(true); // Start loading
      let response;

      if (sessionStorage.getItem("userRole") === 'Admin') {
        response = await axios.post(`Dashboard/AdminDashboard/GetAllAdminDashboard`, {
          FromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
          ToDate: moment(filterInputs.toDate).format('YYYYMMDD'),
          BranchId: filterInputs.Branch?.BranchId || 0,
          senderCountry: filterInputs.senderCountry?.CountryId || 0,
          receiverCountry: filterInputs.receiverCountry?.CountryId || 0
        });
      } else {
        response = await axios.post(`Dashboard/SalesExecutiveDashboard/GetAllSalesExecutiveDashboard`, {
          FromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
          ToDate: moment(filterInputs.toDate).format('YYYYMMDD'),
          UserId: sessionStorage.getItem('UserId'),
          BranchId: filterInputs.Branch?.BranchId || 0,
          senderCountry: filterInputs.senderCountry?.CountryId || 0,
          receiverCountry: filterInputs.receiverCountry?.CountryId || 0
        })
      }
      setadminData(response.data);

      // Ensure TotalSEPerformance data is available
      const totalSEPerformance = response.data?.TotalSEPerformance || [];

      // Set the series data for the chart
      setSeries10((prevSeries) => {
        if (!totalSEPerformance || totalSEPerformance.length === 0) {
          return [] // Return previous series if no data or data is empty
        }

        // Mapping SalesExecutive_Name to x-axis categories
        const salesExecutives = totalSEPerformance.map((item) => item.SalesExecutive_Name);

        // return [
        //   {
        //     name: "Order",
        //     data: totalSEPerformance.map((item) => item.Order_values ?? 0),
        //   },
        //   {
        //     name: "Sales",
        //     data: totalSEPerformance.map((item) => item.Sales_Value ?? 0), // Assuming "NO_Of_Sales" as the shipment equivalent
        //   },
        //   {
        //     name: "Collection",
        //     data: totalSEPerformance.map(
        //       (item) => (item.Receipt_Value ?? 0)
        //     ), // Difference between Orders and Sales
        //   }
        // ];
        return [
          {
            name: "Order",
            data: totalSEPerformance.map((item) => ({
              x: item.SalesExecutive_Name,
              y: item.Order_values ?? 0,
              NoofBox: item.NoofBox ?? 0,
              OrderWeight: item.Order_weight ?? 0,
              OrderCount: item.NO_Of_Orders ?? 0
            })),
          },
          {
            name: "Sales",
            data: totalSEPerformance.map((item) => ({
              x: item.SalesExecutive_Name,
              y: item.Sales_Value ?? 0,
              NoofBox: item.NoofBox ?? 0,
              OrderWeight: item.Order_weight ?? 0,
              OrderCount: item.NO_Of_Sales ?? 0
            })),
          },
          {
            name: "Collection",
            data: totalSEPerformance.map((item) => ({
              x: item.SalesExecutive_Name,
              y: item.Receipt_Value ?? 0,
              OrderCount: item.NO_Of_Receipts ?? 0
            })), // No NoofBox or OrderWeight here
          },
        ];
      });


      if (sessionStorage.getItem('userRole') === 'Admin') {
        // Ensure TotalSEPerformance data is available
        const Branchwisesales = response.data?.BranchWiseSales || [];
        // Branch Wise Sales
        setSeries11((prevSeries) => {
          if (!Branchwisesales || Branchwisesales.length === 0) {
            return [] // Return previous series if no data or data is empty
          }

          // Mapping SalesExecutive_Name to x-axis categories
          const salesExecutives = Branchwisesales.map((item) => item.SalesExecutive_Name);
          return [
            {
              // name: Branchwisesales.map((item) => item.Branch_Name ?? 0),
              name: "Total Sales Value",
              data: Branchwisesales.map((item) => ({
                x: item.Branch_Name,
                y: item.total_sales_generated_value ?? 0,
                NoofBox: item.NoofBox ?? 0,
                OrderWeight: item.Order_weight ?? 0,
              }))
            },
            // {
            //   name: "Sales",
            //   data: totalSEPerformance.map((item) => item.Sales_Value ?? 0), // Assuming "NO_Of_Sales" as the shipment equivalent
            // },
            // {
            //   name: "Collection",
            //   data: totalSEPerformance.map(
            //     (item) => (item.Receipt_Value ?? 0)
            //   ), // Difference between Orders and Sales
            // },
          ];
        });
      } else {
        const Branchwisesales = []
      }

    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const GetPopOverDatas = async () => {
    try {
      if (sessionStorage.getItem('userRole') === 'Admin') {
        const response = await axios.get(`Dashboard/AdminDashboard/GetAdminNewGoodsData/${sessionStorage.getItem('UserId')}`);
        setpopOverData(response.data);
      } else {
        const response = await axios.get(`Dashboard/SalesExecutiveDashboard/GetSalesNewGoodsData/${sessionStorage.getItem('UserId')}`);
        setpopOverData(response.data);
      }
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    } finally {
      // setLoading(false); // Stop loading
    }
  };

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      const response = await axios.post('signup/GetBranchList', requestData, config);
      // const data = response.data.filter((i) => i.webBranch === 'Y');
      setBranchList(response.data.filter((i) => i.webBranch !== 'N' && i.BranchName.trim().toLowerCase() !== 'other'));
      // setBranchList(data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const totalSEPerformance = adminData?.TotalSEPerformance || [];

  const options10 = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '10%',
        borderRadius: 5,
        borderRadiusApplication: 'end'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: totalSEPerformance.map((item) => item.SalesExecutive_Name), // Set SalesExecutive_Name as categories
    },
    yaxis: {
      title: {
        text: ''
      }
    },
    fill: {
      opacity: 1
    },
    // tooltip: {
    //   y: {
    //     formatter: (val) => ` ${val} `
    //   }
    // }
    // tooltip: {
    //   y: {
    //     formatter: (val, { series, seriesIndex, dataPointIndex, w }) => {

    //       console.log('Tooltip', {
    //         val,
    //         series,
    //         seriesIndex,
    //         dataPointIndex,
    //         w
    //       })
    //       const kgValue = w.config.series[1]?.data[dataPointIndex] || 0;
    //       const noOfBoxes = w.config.series[3]?.data[dataPointIndex] || 0;
    //       const orderWeight = w.config.series[4]?.data[dataPointIndex] || 0;

    //       return `Value: ${val} <br> No. of Boxes: ${noOfBoxes} <br> Order Weight: ${orderWeight}`;

    //     }
    //   }
    // }
    tooltip: {
      y: {
        formatter: (val, { seriesIndex, dataPointIndex, w }) => {
          // Get the current data point
          const currentData = w.config.series[seriesIndex].data[dataPointIndex];

          // Show extra values only for "Order" and "Sales"

          // if (seriesIndex === 0 || seriesIndex === 1) { 
          //   const noOfBoxes = currentData.NoofBox ?? 0;
          //   const orderWeight = currentData.OrderWeight ?? 0;
          //   const totalCount = currentData.OrderCount ?? 0;
          //   return `Total Count: ${totalCount} <br> Value: ${val} <br> Total Boxes: ${noOfBoxes} <br> Total Weight: ${orderWeight}`;
          // }

          const noOfBoxes = (seriesIndex === 0 || seriesIndex === 1) ? ((currentData.OrderCount !== 0 ? currentData.NoofBox : 0) ?? 0) : null;
          const orderWeight = (seriesIndex === 0 || seriesIndex === 1) ? ((currentData.OrderCount !== 0 ? currentData.OrderWeight : 0) ?? 0) : null;
          const totalCount = currentData.OrderCount ?? 0;

          let tooltipText = `Total Count: ${totalCount} <br> Value: ${val}`;

          if (seriesIndex === 0 || seriesIndex === 1) {
            tooltipText += `<br> Cargo- No of Boxes: ${noOfBoxes} <br> Courier-No of kgs: ${orderWeight}`;
          }

          return tooltipText;
          // Default for "Collection" (seriesIndex 2)
          // return `Value: ${val}`;
        }
      }
    }


  };

  // if (sessionStorage.getItem('userRole') === 'Admin') {
  const Branchwisesales = adminData?.BranchWiseSales || [];

  const options11 = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '5%',
        borderRadius: 5,
        borderRadiusApplication: 'end'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      // categories: Branchwisesales.map((item) => item.Branch_Name), // Set SalesExecutive_Name as categories
    },
    yaxis: {
      title: {
        text: ''
      }
    },
    fill: {
      opacity: 1
    },
    // tooltip: {
    //   y: {
    //     formatter: (val) => ` ${val} `
    //   }
    // }
    tooltip: {
      y: {
        formatter: (val, { seriesIndex, dataPointIndex, w }) => {

          // Get the current data point
          const currentData = w.config.series[seriesIndex].data[dataPointIndex];

          // Show extra values only for "Order" and "Sales"


          const noOfBoxes = currentData.NoofBox ?? 0;
          const orderWeight = currentData.OrderWeight ?? 0;

          return `Value: ${val} <br> Cargo- No of Boxes: ${noOfBoxes} <br> Courier-No of kgs: ${orderWeight}`;
          // Default for "Collection" (seriesIndex 2)
          // return `Value: ${val}`;
        }
      }
    }
  };
  // }


  const handleFilterInputs = (e) => {
    setFilterInputs({
      ...filterInputs,
      [e.target.name]: e.target.value,
    });
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <CircularProgress />
      </div>
    );
  }


  // New Item Order Popover
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  // Ledger Approval Action
  const handleClick1 = (event) => {
    setanchorEl1(event.currentTarget);
  };

  const handleClose1 = () => {
    setanchorEl1(null);
  };

  const open1 = Boolean(anchorEl1);
  const id1 = open1 ? 'simple-popover1' : undefined;

  // Complaint Action
  const handleClick2 = (event) => {
    setanchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setanchorEl2(null);
  };

  const open2 = Boolean(anchorEl2);
  const id2 = open2 ? 'simple-popover2' : undefined;

  // Helper component for consistent detail items
  function DetailItem({ icon, label, value }) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        {React.cloneElement(icon, {
          fontSize: "small",
          sx: { color: 'text.secondary', flexShrink: 0 }
        })}
        <Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1 }}>
            {label}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {value || '-'}
          </Typography>
        </Box>
      </Box>
    );
  }

  // Helper function for avatar color
  function stringToColor(string) {
    const colors = [
      '#ffadad', '#ffd6a5', '#fdffb6', '#caffbf',
      '#9bf6ff', '#a0c4ff', '#bdb2ff', '#ffc6ff'
    ];
    const index = string.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0) % colors.length;
    return colors[index];
  }

  return (
    <>

      <Container maxWidth={'xl'} sx={{ pt: 2, mx: "auto" }} elevation={3} style={{ marginLeft: "12px", marginRight: "12px" }}>
        {/* <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Hi,{sessionStorage.getItem('UserName')} Welcome back
          </Typography>
        </Box> */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%", mb: 3 }}>
          {sessionStorage.getItem('userRole') === 'Admin' && (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Chip
                  aria-describedby={id1}
                  variant="outlined"
                  onClick={handleClick1}
                  avatar={
                    <Badge
                      color="warning"
                      badgeContent={popOverData.PendingLedgerCount[0].Ledger_Pending_approval || 0}
                      overlap="circular"
                      sx={{
                        '& .MuiBadge-badge': {
                          right: -3,
                          top: -3,
                          minWidth: 20,
                          height: 20,
                          fontSize: '0.75rem',
                          fontWeight: 'bold'
                        }
                      }}
                    >
                      <Avatar sx={{
                        width: 24,
                        height: 24,
                        bgcolor: 'warning.light',
                        color: 'warning.dark'
                      }}>
                        <DescriptionIcon sx={{ fontSize: 16 }} />
                      </Avatar>
                    </Badge>
                  }
                  label="Pending Approvals"
                  sx={{
                    marginRight: '17px',
                    marginLeft: '8px',
                    cursor: 'pointer',
                    borderColor: 'warning.light',
                    color: 'warning.dark',
                    '&:hover': {
                      backgroundColor: 'warning.light',
                      borderColor: 'warning.main'
                    },
                    '& .MuiChip-label': {
                      paddingLeft: '8px',
                      fontWeight: 'medium'
                    }
                  }}
                />

                {popOverData.PendingLedgerCount[0].Ledger_Pending_approval !== 0 && (
                  <Popover
                    id={id1}
                    open={open1}
                    anchorEl={anchorEl1}
                    onClose={handleClose1}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        width: 320,
                        maxHeight: 300,
                        borderRadius: '12px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                        // overflow: 'hidden',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                          width: '6px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#c1c1c1',
                          borderRadius: '3px',
                        },
                      },
                    }}
                  >
                    <Box sx={{ p: 2 }}>
                      <List dense sx={{ py: 0 }}>
                        {popOverData.PendingLedgerDetails.map((item, index) => (
                          <React.Fragment key={index}>
                            <ListItem sx={{
                              px: 0,
                              py: 1.5,
                              '&:hover': { backgroundColor: 'action.hover' }
                            }}>
                              <ListItemAvatar>
                                <Avatar sx={{
                                  width: 32,
                                  height: 32,
                                  bgcolor: 'warning.light',
                                  color: 'warning.dark'
                                }}>
                                  {item.CustomerName.charAt(0)}
                                </Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  <Typography variant="subtitle2" sx={{ fontWeight: '500' }}>
                                    {item.CustomerName}
                                  </Typography>
                                }
                                secondary={
                                  <>
                                    <Box component="span" sx={{ display: 'block' }}>
                                      <PhoneIcon sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                                      {item.Phone}
                                    </Box>
                                    <Box component="span" sx={{ display: 'block' }}>
                                      <EmailIcon sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                                      {item.EmailId}
                                    </Box>
                                  </>
                                }
                                secondaryTypographyProps={{ variant: 'body2' }}
                              />
                            </ListItem>
                            {index < popOverData.PendingLedgerDetails.length - 1 && (
                              <Divider sx={{ my: 0.5 }} />
                            )}
                          </React.Fragment>
                        ))}
                      </List>
                    </Box>
                  </Popover>
                )}
              </Box>
            </>
          )}

          <Chip
            aria-describedby={id}
            variant="outlined"
            onClick={handleClick}
            avatar={
              <Badge
                color="primary"
                badgeContent={popOverData.NewGoodsCount?.[0]?.total_new_Item_Exists ?? 0}
                overlap="circular"
                sx={{
                  '& .MuiBadge-badge': {
                    right: -3,
                    top: -3,
                    minWidth: '20px',
                    height: '20px',
                    fontSize: '0.75rem',
                    fontWeight: 'bold',
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText'
                  }
                }}
              >
                <Avatar sx={{
                  width: 24,
                  height: 24,
                  bgcolor: 'primary.light',
                  color: 'primary.main'
                }}>
                  <AddShoppingCartIcon sx={{ fontSize: 16 }} />
                </Avatar>
              </Badge>
            }
            label="New Item Orders"
            sx={{
              marginRight: "25px",
              marginLeft: "8px",
              cursor: "pointer",
              borderColor: 'primary.light',
              color: 'primary.dark',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'primary.light',
                color: 'primary.dark',
                borderColor: 'primary.main',
                '& .MuiAvatar-root': {
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText'
                }
              },
              '& .MuiChip-label': {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontWeight: 'medium'
              },
              transition: 'all 0.2s ease-in-out'
            }}
          />
          {popOverData.NewGoodsCount?.[0]?.total_new_Item_Exists !== 0 &&
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                sx: {
                  maxHeight: 280,
                  width: 280,
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                  padding: '4px 0',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#c1c1c1',
                    borderRadius: '3px',
                  },
                },
              }}
            >
              {popOverData.NewGoodsDetails.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    padding: '12px 16px',
                    '&:hover': {
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px'
                    }
                  }}
                >
                  {/* Order Header */}
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '8px'
                  }}>
                    <Box sx={{
                      width: 32,
                      height: 32,
                      borderRadius: '4px',
                      backgroundColor: item.OrderType === 'Courier' ? '#e3f2fd' : '#fff8e1', // Blue for Courier, Yellow for Cargo
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: item.OrderType === 'Courier' ? '#1976d2' : '#ff8f00' // Blue for Courier, Orange for Cargo
                    }}>
                      {item.OrderType === 'Courier' ? (
                        <LocalShippingIcon fontSize="small" /> // Truck icon for Courier
                      ) : (
                        <LocalConvenienceStoreIcon fontSize="small" /> // Warehouse icon for Cargo
                      )}
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        Order #{item.orderNo}
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        {moment(item.created_On).format('MMM D, YYYY')}
                      </Typography>
                    </Box>
                    <Chip
                      label={item.OrderType}
                      size="small"
                      sx={{
                        backgroundColor: item.OrderType === 'NEW' ? '#e3f2fd' : '#fff8e1',
                        color: item.OrderType === 'NEW' ? '#1976d2' : '#ff8f00',
                        fontWeight: 600,
                        fontSize: '0.65rem',
                        height: '20px',
                        textTransform: 'uppercase'
                      }}
                    />
                  </Box>

                  {/* Order Details */}
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginLeft: '40px',
                    marginTop: '4px'
                  }}>
                    <Box sx={{
                      minWidth: '24px',
                      display: 'flex',
                      justifyContent: 'center'
                    }}>
                      <CircleIcon sx={{
                        fontSize: '8px',
                        color: 'text.secondary'
                      }} />
                    </Box>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      Created: {moment(item.created_On).format('h:mm A')}
                    </Typography>
                  </Box>

                  {/* Divider - Only show if not last item */}
                  {index < popOverData.NewGoodsDetails.length - 1 && (
                    <Divider sx={{
                      borderColor: '#f0f0f0',
                      margin: '12px 0 8px 40px',
                      width: 'calc(100% - 40px)'
                    }} />
                  )}
                </Box>
              ))}
            </Popover>
          }

          {/* Complaint Badge */}
          <Chip
            aria-describedby={id2}
            variant="outlined"
            onClick={handleClick2}
            avatar={
              <Badge
                color="error"
                badgeContent={popOverData?.ComplaintsDetails?.length || 0}
                overlap="circular"
                sx={{
                  '& .MuiBadge-badge': {
                    right: -2,
                    top: -2,
                    minWidth: '18px',
                    height: '18px',
                    fontSize: '0.7rem',
                    fontWeight: 'bold'
                  }
                }}
              >
                <Avatar sx={{
                  width: 24,
                  height: 24,
                  bgcolor: 'error.light',
                  color: 'error.contrastText'
                }}>
                  <WarningIcon sx={{ fontSize: 16 }} />
                </Avatar>
              </Badge>
            }
            label="Complaint Action"
            sx={{
              marginRight: "25px",
              cursor: "pointer",
              borderColor: 'error.light',
              color: 'error.dark',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'error.light',
                color: 'error.dark',
                borderColor: 'error.main',
                '& .MuiAvatar-root': {
                  bgcolor: 'error.main',
                }
              },
              '& .MuiChip-label': {
                paddingLeft: '8px',
                fontWeight: '500'
              },
              transition: 'all 0.2s ease'
            }}
          />
          {popOverData?.ComplaintsDetails?.length !== 0 &&
            <Popover
              id={id2}
              open={open2}
              anchorEl={anchorEl2}
              onClose={handleClose2}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              PaperProps={{
                sx: {
                  maxHeight: 400,
                  width: 320,
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                  padding: '8px 0',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#c1c1c1',
                    borderRadius: '3px',
                  },
                },
              }}
            >
              {popOverData.ComplaintsDetails.map((item, index) => (
                <Box key={index} sx={{ padding: '12px 16px', '&:hover': { backgroundColor: '#f8f9fa' } }}>
                  {/* Customer Header */}
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '10px'
                  }}>
                    <Avatar sx={{
                      width: 36,
                      height: 36,
                      bgcolor: stringToColor(item.CustomerName),
                      color: 'white',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}>
                      {item.CustomerName.split(' ').map(n => n[0]).join('')}
                    </Avatar>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {item.CustomerName}
                      </Typography>
                      <Chip
                        label={item.shipment_type}
                        size="small"
                        sx={{
                          backgroundColor: item.shipment_type === 'CARGO' ? '#e3f2fd' : '#fff8e1',
                          color: item.shipment_type === 'CARGO' ? '#1976d2' : '#ff8f00',
                          fontWeight: 600,
                          fontSize: '0.7rem',
                          height: '20px',
                          textTransform: 'uppercase'
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Details Section */}
                  <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '8px 12px',
                    marginLeft: '46px'
                  }}>
                    <DetailItem icon={<ReceiptIcon />} label="Booking No" value={item.BookOrderNo} />
                    <DetailItem icon={<PhoneIcon />} label="Phone" value={item.Phone} />
                    <DetailItem icon={<BusinessIcon />} label="Branch" value={item.Branch_Name} />
                    <DetailItem icon={<CalendarTodayIcon />} label="Reg. Date" value={moment.utc(item.complaint_date).format('MMM D, h:mm A')} />
                    {sessionStorage.getItem('userRole') === 'Admin' && (
                      <DetailItem icon={<BadgeIcon />} label="Sales Exec" value={item.SalesExecutive} />
                    )}
                  </Box>

                  {index < popOverData.ComplaintsDetails.length - 1 && (
                    <Divider sx={{
                      borderColor: '#f0f0f0',
                      margin: '12px 0 8px 46px',
                      width: 'calc(100% - 46px)'
                    }} />
                  )}
                </Box>
              ))}
            </Popover>
          }
        </Box>
        <Box sx={{ borderTop: 'none', py: 0, pb: 2 }}>
          <Grid container spacing={2} rowSpacing={2} columnSpacing={1} alignItems="center" px={2}>
            <Grid container item md={7} xs={12} spacing={2} columnSpacing={1} alignItems="center">
              <Grid item md={4} xs={12}>
                <Autocomplete
                  options={branchList}
                  getOptionLabel={(branch) => branch.BranchName}
                  renderOption={(props, branch) => (
                    <li {...props} key={branch.BranchId} style={{ fontSize: '14px' }}>
                      {branch.BranchName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option.BranchId === value?.BranchId}
                  value={filterInputs.Branch || null}
                  name="Branch"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, Branch: value });
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Branch"
                      InputProps={{
                        ...params.InputProps,
                        style: { fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        style: { fontSize: '14px' },
                      }}
                    />
                  )}
                />

              </Grid>
              <Grid item md={4} xs={12}>
                <Autocomplete
                  options={countryList || []}
                  getOptionLabel={(country) => country.CountryName || ''}
                  renderOption={(props, country) => (
                    <li {...props} key={country.CountryId} style={{ fontSize: '14px' }}>
                      {country.CountryName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                  value={filterInputs.senderCountry || null}
                  name="senderCountry"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, senderCountry: value });
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Sender Country"
                      InputProps={{
                        ...params.InputProps,
                        style: { fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        style: { fontSize: '14px' },
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Autocomplete
                  options={countryList || []}
                  getOptionLabel={(country) => country.CountryName || ''}
                  renderOption={(props, country) => (
                    <li {...props} key={country.CountryId} style={{ fontSize: '14px' }}>
                      {country.CountryName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                  value={filterInputs.receiverCountry || null}
                  name="receiverCountry"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, receiverCountry: value });
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Receiver Country"
                      InputProps={{
                        ...params.InputProps,
                        style: { fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        style: { fontSize: '14px' },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid container item md={5} xs={12} spacing={2} columnSpacing={1} alignItems="center">
              <Grid item md={5} xs={12} >
                <TextField
                  fullWidth
                  label="From Date"
                  type="date"
                  name="fromDate"
                  value={filterInputs.fromDate}
                  onChange={handleFilterInputs}
                  InputLabelProps={{
                    shrink: true,
                    style: { fontSize: '14px' }
                  }}
                  variant="outlined"
                  size="small"
                  inputProps={{
                    max: '9999-12-31',
                    style: { fontSize: '14px', padding: '8px' }
                  }}
                />
              </Grid>
              <Grid item md={5} xs={12} >
                <TextField
                  fullWidth
                  label="To Date"
                  type="date"
                  name="toDate"
                  value={filterInputs.toDate}
                  onChange={handleFilterInputs}
                  InputLabelProps={{
                    shrink: true,
                    style: { fontSize: '14px' }
                  }}
                  variant="outlined"
                  size="small"
                  inputProps={{
                    max: '9999-12-31',
                    style: { fontSize: '14px', padding: '8px' }
                  }}
                />
              </Grid>
              <Grid item md={2} xs={12}>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  fullWidth={{ xs: true, md: false }}
                  onClick={() => {
                    GetAllAdminDashboard()
                    GetPopOverDatas()
                  }}
                  sx={{
                    fontSize: '14px'
                  }}
                  startIcon={<CalendarTodayIcon sx={{ fontSize: '14px' }} />}
                >
                  view
                </Button>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, width: "100%", alignItems: { xs: "stretch", sm: "center" }, flexDirection: { xs: "column", sm: "row" } }}>
              <TextField
                label="From Date"
                type="date"
                name="fromDate"
                value={filterInputs.fromDate}
                onChange={handleFilterInputs}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                size="small"
                inputProps={{ max: "9999-12-31" }}
              />
              <TextField
                label="To Date"
                type="date"
                name="toDate"
                value={filterInputs.toDate}
                onChange={handleFilterInputs}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                size="small"
                inputProps={{ max: "9999-12-31" }}
              />
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => {
                  GetAllAdminDashboard()
                  GetPopOverDatas()
                }}
                startIcon={<CalendarTodayIcon />}
              >
                View
              </Button>
            </Box>
          </Grid> */}
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Sales Generated" total={adminData?.TotalSalesGenerated[0]?.total_sales_generated_value} icon={'icon-park-solid:shopping'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Collection" total={adminData?.TotalCollectionGenerated[0]?.total_collection_value ?? 0}
              color="info" icon={'tabler:clipboard-data'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Number of New Clients" total={adminData?.TotalNewClients[0]?.no_of_new_client_web} color="warning" icon={'ic:baseline-account-circle'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Number Of Orders" total={adminData?.TotalNoofOrders[0]?.total_confirmed_orders} color="error" icon={'fontisto:shopping-bag-1'} />
          </Grid>

          <Grid item xs={12} lg={5}>
            <AppCurrentVisits
              title="Funnel Tracker"
              chartData={[
                { label: 'Warm', value: adminData.FunnelTracker?.[0]?.Warm_Percentage ?? 0 },
                { label: 'Cold', value: adminData.FunnelTracker?.[0]?.Cold_Percentage ?? 0 },
                { label: 'No_Lead', value: adminData.FunnelTracker?.[0]?.No_Lead_Percentage ?? 0 },
                { label: 'Hot', value: adminData.FunnelTracker?.[0]?.Hot_Percentage ?? 0 },
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.info.main,
                theme.palette.warning.main,
                theme.palette.error.main,
              ]}
            />
          </Grid>

          {sessionStorage.getItem('userRole') === 'Admin' ?
            <Grid item xs={12} lg={7}>
              {/* <AppConversionRates
              title="Conversion Rates"
              subheader="(+43%) than last year"
              chartData={[
                { label: 'Italy', value: 400 },
                { label: 'Japan', value: 430 },
                { label: 'China', value: 448 },
                { label: 'Canada', value: 470 },
                { label: 'France', value: 540 },
                { label: 'Germany', value: 580 },
                { label: 'South Korea', value: 690 },
                { label: 'Netherlands', value: 1100 },
                { label: 'United States', value: 1200 },
                { label: 'United Kingdom', value: 1380 },
              ]}
            /> */}
              <Card>

                <CardHeader title={'Branch Wise Sales'} subheader={''} />
                <ReactApexChart
                  key={JSON.stringify(Series11)}
                  options={options11}
                  series={Series11}
                  type="bar"
                  height={380}
                />

              </Card>
            </Grid>
            :
            <Grid item xs={12} lg={7}>
              <AppOrderTimeline
                title="Follow-up's For The Day"
                list={adminData.FollowUpForTheday.map((item) => ({
                  id: faker.datatype.uuid(),
                  title: (
                    <>
                      <div><strong>Customer :</strong> {item.CustomerName}</div>
                      {item.OrderNo !== '0' && (
                        <div><strong>Order No :</strong> {item.OrderNo} <strong>; Order Date :</strong> {moment(item.OrderDate).format('DD-MM-YYYY')}</div>
                      )}
                      <div><strong>Follow-up Date :</strong> {moment(item.followupDate).format('DD-MM-YYYY')} <strong>; Time :</strong> {moment(item.followupDate).format('hh:mm A')}</div>
                      <div><strong>Comments :</strong> {item.remarks}</div>
                    </>
                  ),
                  type: "followup",

                  // time: item.followupDate, // Keeping original time for sorting purposes
                }))}
                style={{ height: '460px', overflowY: 'auto' }}
              />

            </Grid>
          }

          <Grid item xs={12}>
            {/* <AppWebsiteVisits
              title="Website Visits"
              subheader="(+43%) than last year"
              chartLabels={[
                '01/01/2003',
                '02/01/2003',
                '03/01/2003',
                '04/01/2003',
                '05/01/2003',
                '06/01/2003',
                '07/01/2003',
                '08/01/2003',
                '09/01/2003',
                '10/01/2003',
                '11/01/2003',
              ]}
              chartData={[
                {
                  name: 'Team A',
                  type: 'column',
                  fill: 'solid',
                  data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                },
                {
                  name: 'Team B',
                  type: 'area',
                  fill: 'gradient',
                  data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                },
                {
                  name: 'Team C',
                  type: 'line',
                  fill: 'solid',
                  data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
                },
              ]}
            /> */}
            <Card>

              <CardHeader title={sessionStorage.getItem('userRole') === 'Admin' ? 'Sales Executive -performance' : 'Sales Analytics'} subheader={''} />
              <ReactApexChart
                key={JSON.stringify(Series10)}
                options={options10}
                series={Series10}
                type="bar"
                height={380}
              />

            </Card>
          </Grid>
          {/* 
          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject
              title="Current Subject"
              chartLabels={['English', 'History', 'Physics', 'Geography', 'Chinese', 'Math']}
              chartData={[
                { name: 'Series 1', data: [80, 50, 30, 40, 100, 20] },
                { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
                { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
              ]}
              chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate
              title="News Update"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: faker.name.jobTitle(),
                description: faker.name.jobTitle(),
                image: `/assets/images/covers/cover_${index + 1}.jpg`,
                postedAt: faker.date.recent(),
              }))}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Order Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  '1983, orders, $4220',
                  '12 Invoices have been paid',
                  'Order #37745 from September',
                  'New order placed #XF-2356',
                  'New order placed #XF-2346',
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite
              title="Traffic by Site"
              list={[
                {
                  name: 'FaceBook',
                  value: 323234,
                  icon: <Iconify icon={'eva:facebook-fill'} color="#1877F2" width={32} />,
                },
                {
                  name: 'Google',
                  value: 341212,
                  icon: <Iconify icon={'eva:google-fill'} color="#DF3E30" width={32} />,
                },
                {
                  name: 'Linkedin',
                  value: 411213,
                  icon: <Iconify icon={'eva:linkedin-fill'} color="#006097" width={32} />,
                },
                {
                  name: 'Twitter',
                  value: 443232,
                  icon: <Iconify icon={'eva:twitter-fill'} color="#1C9CEA" width={32} />,
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppTasks
              title="Tasks"
              list={[
                { id: '1', label: 'Create FireStone Logo' },
                { id: '2', label: 'Add SCSS and JS files if required' },
                { id: '3', label: 'Stakeholder Meeting' },
                { id: '4', label: 'Scoping & Estimations' },
                { id: '5', label: 'Sprint Showcase' },
              ]}
            />
          </Grid> */}
        </Grid>
      </Container>
    </>
  );
}
